import { render, staticRenderFns } from "./WangEditor.vue?vue&type=template&id=68be031e&"
import script from "./WangEditor.vue?vue&type=script&lang=js&"
export * from "./WangEditor.vue?vue&type=script&lang=js&"
import style0 from "./WangEditor.vue?vue&type=style&index=0&scope=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "WangEditor.vue"
export default component.exports